import styled from "styled-components";

/**
 * Control, button, and status UI components
 */
export const AssemblyControls = {
    Button: styled.button`
      border: 1px solid #b0c4de;
      background: white;
      color: #0b3d91;
      padding: 8px 12px;
      border-radius: 8px;
      cursor: pointer;
      font-weight: 600;
    `,
    SetupSelect: styled.select`
      border: 1px solid #cbd5e1;
      border-radius: 8px;
      padding: 8px;
      min-width: 220px;
    `,
    SmallButton: styled.button`
      border: 1px solid #cbd5e1;
      padding: 6px 8px;
      border-radius: 6px;
      background: #f8fafc;
      color: #0f172a;
      font-size: 12px;
      cursor: pointer;
    `,
    Select: styled.select`
      padding: 8px;
      border-radius: 8px;
      border: 1px solid #cbd5e1;
      background: white;
    `,
    Hint: styled.div`
      font-size: 12px;
      color: #475569;
    `,
    Inline: styled.span`
      display: inline-flex;
      align-items: center;
      gap: 6px;
      flex-wrap: wrap;
    `,
    PowerBadge: styled.div`
      display: inline-flex;
      align-items: center;
      gap: 6px;
      padding: 6px 10px;
      background: #ecfeff;
      border: 1px solid #bae6fd;
      border-radius: 999px;
      color: #0f172a;
      font-size: 13px;
      font-weight: 600;
    `,
    StatusText: styled.div`
      font-size: 12px;
      font-weight: 700;
      color: #0f172a;
      display: flex;
      gap: 6px;
      align-items: center;
      flex-wrap: wrap;
    `,
    StatusPill: styled.div<{ $tone?: "warn" | "ok" | "info" }>`
      display: inline-flex;
      align-items: center;
      gap: 4px;
      padding: 4px 8px;
      border-radius: 999px;
      font-size: 11px;
      font-weight: 700;
      color: ${props => props.$tone === "warn" ? "#854d0e" : props.$tone === "ok" ? "#166534" : "#0f172a"};
      background: ${props => props.$tone === "warn" ? "#fef3c7" : props.$tone === "ok" ? "#dcfce7" : "#e0f2fe"};
    `,
    CompactRow: styled.div`
      display: flex;
      align-items: center;
      gap: 8px;
      justify-content: space-between;
    `,
    ControlButton: styled.button<{ $active?: boolean }>`
      border: 1px solid #cbd5e1;
      background: ${props => props.$active ? "#22c55e" : "#f8fafc"};
      color: ${props => props.$active ? "#064e3b" : "#0f172a"};
      padding: 6px 10px;
      border-radius: 8px;
      font-weight: 800;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      gap: 6px;
      box-shadow: inset 0 1px 0 rgba(255,255,255,0.65);
    `,
    ToggleButton: styled.button<{ $on?: boolean }>`
      border: 1px solid #f59e0b;
      background: ${props => props.$on ? "#fef08a" : "#fff7ed"};
      color: #92400e;
      padding: 4px 8px;
      border-radius: 999px;
      font-weight: 700;
      display: inline-flex;
      align-items: center;
      gap: 4px;
      cursor: pointer;
    `,
    ThroughputRow: styled.div`
      display: flex;
      align-items: center;
      gap: 6px;
      flex-wrap: wrap;
      margin-top: 6px;
    `,
    ThroughputChip: styled.div`
      display: inline-flex;
      align-items: center;
      gap: 6px;
      padding: 4px 8px;
      border-radius: 999px;
      background: #f1f5f9;
      border: 1px solid #e2e8f0;
      font-size: 12px;
      font-weight: 700;
    `,
    WarningBanner: styled.div`
      margin-top: 8px;
      padding: 10px 12px;
      background: #fef2f2;
      border: 1px solid #fecdd3;
      color: #7f1d1d;
      border-radius: 10px;
      display: flex;
      align-items: center;
      gap: 8px;
      font-weight: 700;
    `,
    PowerHint: styled.span`
      font-size: 12px;
      color: #991b1b;
    `,
};
